export const STRIPE_PAYMENT_LINK = "https://buy.stripe.com/fZu8wI7DK9mG4b96NPeME00";

export const ASSETS = {
  heroVideo:
    "https://customer-assets.emergentagent.com/job_awakened-intel/artifacts/ks5gx6r9_hf_20260707_203021_7f89a6c2-1da9-4802-bb0f-f1153f8ea469.mp4",
  fannedCards:
    "https://customer-assets.emergentagent.com/job_awakened-intel/artifacts/9b3ppz85_image-1783458543860.webp",
  boxMockup:
    "https://customer-assets.emergentagent.com/job_awakened-intel/artifacts/yzbk8zdj_image-1783458533443.webp",
};

export const AUDIENCE = [
  { title: "Veterans", icon: "Shield", desc: "Those who carried the weight and came home changed." },
  { title: "Law Enforcement", icon: "Crosshair", desc: "The ones who answer when everyone else runs." },
  { title: "EMTs & Medics", icon: "Activity", desc: "Hands that hold the line between life and loss." },
  { title: "Firefighters", icon: "Flame", desc: "Walking into the smoke so others can walk out." },
  { title: "Shadow Workers", icon: "Eye", desc: "Trauma survivors doing the quiet, brutal work." },
  { title: "Between Worlds", icon: "Compass", desc: "Anyone who's held space for others in the dark." },
];

export const WHATS_INSIDE = [
  {
    title: "49 Hand-Illustrated Cards",
    icon: "Layers",
    desc: "Black-and-white graphic-novel ink art with symbolic color accents — a single red flare, glowing defib pads, an amber dawn.",
  },
  {
    title: "Printed Companion Guidebook",
    icon: "BookOpen",
    desc: "Layered meanings, intuitive messages, grounded spiritual insight, and a self-reflection question for every card.",
  },
  {
    title: "The Box",
    icon: "Box",
    desc: "A durable, ritual-ready box that keeps the deck protected and close at hand.",
  },
  {
    title: "Gold-Gilded Edges",
    icon: "Sparkles",
    desc: "Every card is finished with real gold gilded edges — a premium, ritual-worthy touch that catches the light when you fan the deck.",
  },
  {
    title: "4 Tactical Spreads",
    icon: "LayoutGrid",
    desc: "Field-tested layouts — Tactical Insight, Threat & Response, The Patrol Check, and The Mission Brief.",
  },
];

export const CARDS = [
  {
    name: "INCOMING",
    keywords: ["Awakening", "Divine message", "A shift"],
    img: "https://customer-assets.emergentagent.com/job_awakened-intel/artifacts/e2hvpasm_1%20%282%29.png",
  },
  {
    name: "PULSE CHECK",
    keywords: ["Revive", "Release", "Respond"],
    img: "https://customer-assets.emergentagent.com/job_awakened-intel/artifacts/397w1iqq_5%20%281%29.png",
  },
  {
    name: "THE ORDERS",
    keywords: ["Activation", "Direction", "Inner calling"],
    img: "https://customer-assets.emergentagent.com/job_awakened-intel/artifacts/gs177qco_3%20%281%29.png",
  },
  {
    name: "FLASHOVER",
    keywords: ["Overload", "Critical Mass", "Transformation"],
    img: "https://customer-assets.emergentagent.com/job_awakened-intel/artifacts/8kiqmigk_24.png",
  },
  {
    name: "BURNOUT",
    keywords: ["Exhaustion", "Silence", "Surrender"],
    img: "https://customer-assets.emergentagent.com/job_awakened-intel/artifacts/12e1u6fu_7%20%281%29.png",
  },
];

export const SPREADS = [
  { name: "Tactical Insight", cards: "1-CARD", desc: "A single round of intel. One question, one clear read." },
  { name: "Threat & Response", cards: "2-CARD", desc: "What's coming at you, and how you meet it." },
  { name: "The Patrol Check", cards: "3-CARD", desc: "Past ground, current position, next objective." },
  { name: "The Mission Brief", cards: "4-CARD", desc: "Objective, obstacle, resources, and the outcome ahead." },
];

export const FAQ = [
  {
    q: "When will it ship?",
    a: "First-wave decks ship Fall 2026. Pre-order now to lock your place in the first printing — physical tiers ship in the order they were reserved.",
  },
  {
    q: "Is this a physical deck?",
    a: "Yes — it's a physical 49-card oracle deck with a printed companion guidebook and a protective box. There's no digital version; this is a real deck you hold in your hands.",
  },
  {
    q: 'Do I need to be "spiritual" to use it?',
    a: "No. If you've stood in the doorway between worlds and asked what now, this deck speaks your language. No incense required. It works as reflection, as grounding, as inner intel.",
  },
  {
    q: "Is the language really that raw?",
    a: "Yes — it's honest. This isn't love-and-light. It's written in the voice of someone who's seen the dark and chose to hold the line. Gritty, tactical, unfiltered.",
  },
  {
    q: "What's your refund policy?",
    a: "Physical pre-orders can be cancelled for a full refund any time before your deck enters production. Once it ships, reach out and we'll make it right. Questions? Email hello@theowlofmintaka.com.",
  },
  {
    q: "Do you ship internationally?",
    a: "Yes. International shipping is available at checkout for physical tiers. Rates and delivery windows are calculated by destination.",
  },
];
